import React from 'react';

import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import Button from '@atlaskit/button';
import PageHeader from '@atlaskit/page-header';

import { StorageOfUniqueServices } from '@qality/common-service';

import { useTestCaseExecutionStatusPageContext } from '../TestCaseExecutionStatusPageProvider';
import {
  BreadcrumbsStyled,
  SubTextWrapperStyled,
} from './TestCaseExecutionStatus.styled';

const STATUSES_SCHEMES_DOCUMENTATION_LINK =
  'https://soldevelo.atlassian.net/wiki/spaces/QS/pages/4582375449/Execution+Status+Schemes';

const STATUSES_DOCUMENTATION_LINK =
  'https://soldevelo.atlassian.net/wiki/spaces/QS/pages/4581425174/Custom+Execution+Statuses';

export default function Header(): JSX.Element {
  const { isEditScreen, changeScreen } =
    useTestCaseExecutionStatusPageContext();

  const openStatusDocumentationPage = (): void => {
    window.open(STATUSES_DOCUMENTATION_LINK, '_blank');
  };

  const openStatusSchemesDocumentationPage = (): void => {
    window.open(STATUSES_SCHEMES_DOCUMENTATION_LINK, '_blank');
  };

  const breadcrumbs = (
    <BreadcrumbsStyled>
      <Breadcrumbs>
        <BreadcrumbsItem
          text='Manage apps'
          key='Manage apps'
          onClick={() =>
            StorageOfUniqueServices.get('AP').navigator.go('site', {
              absoluteUrl:
                StorageOfUniqueServices.get('URLService').getManageAppUrl(),
            })
          }
        />
        <BreadcrumbsItem text='QAlity Plus' key='QAlity Plus' />
        <BreadcrumbsItem
          text='Test Case Execution Status Settings'
          key='Test Case Execution Status Settings'
          onClick={() => isEditScreen && changeScreen()}
        />
        {isEditScreen && (
          <BreadcrumbsItem text='Edit Scheme' key='Edit Scheme' />
        )}
      </Breadcrumbs>
    </BreadcrumbsStyled>
  );

  return (
    <>
      <PageHeader breadcrumbs={breadcrumbs}>
        {isEditScreen
          ? 'Test Case Execution Status Scheme'
          : 'Test Case Execution Status Settings'}
      </PageHeader>
      <SubTextWrapperStyled>
        {isEditScreen ? (
          <>
            <p>
              Modify the set of statuses used for Test Case Execution.&nbsp;
              <Button
                onClick={openStatusSchemesDocumentationPage}
                spacing='none'
                appearance='link'
              >
                Learn how to manage status schemes
              </Button>
            </p>
          </>
        ) : (
          <>
            <p>
              You can customize test execution statuses. Scheme below will be
              used in all projects in this Jira instance.&nbsp;
              <Button
                onClick={openStatusDocumentationPage}
                spacing='none'
                appearance='link'
              >
                Learn more about customizing statuses
              </Button>
            </p>
          </>
        )}
      </SubTextWrapperStyled>
    </>
  );
}
